import { action } from 'satcheljs';

export default action(
    'ON_SELECTED_ACCOUNT_CHANGED',
    (selectedAccountSourceId: string, selectedEmailAddress: string, oldSourceId: string) => ({
        selectedAccountSourceId,
        selectedEmailAddress,
        oldSourceId,
    })
);
